/** @jsxImportSource @emotion/react */
import React, { useState, useImperativeHandle, useEffect, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { GlobalBtnGroup, SubTitleGroup, SubTitleLayout } from 'components/layouts/ContentLayout';
import { useCommonModal } from 'hooks/useCommonModal';
import { getAsstRvwReplyUserDept } from 'apis/asst/IdleAssetReview';
import { GatingContListPopUp } from '../../gtng/popup/GatingContListPopUp';
import { Button } from '@mui/material';
import { IconButton } from 'components/buttons/IconSVG';
import { useMessageBar } from 'hooks/useMessageBar';
import _, { toNumber } from 'lodash';
import { AsstRvwType, IdleAssetCondition, IdleAssetMaster } from 'models/asst/IdleAsset';
import { tb } from '../../../components/layouts/Table';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import { FileuploadBtn } from '../../../components/buttons/CustomButton';
import TableContainer from '@mui/material/TableContainer';
import { findIdleAssetMaster } from '../../../apis/asst/IdleAsset';
import FileUploadPopUp from '../../common/components/FileUploadPopUp';
import { useLocation, useNavigate } from 'react-router-dom';
import { MenuContextType } from '../../../models/admin/Menu';
import { MenuContext } from '../../../App';
import { ComboBox } from '../../../components/selects/ComboBox';
import CustomInputWithSearch from '../../../components/inputs/CustomInputWithSearch';
import useSessionStore from 'stores/useSessionStore';
import { IdleAssetReviewResult } from '../../../models/asst/IdleAssetReviewResult';
import { CommonUtil } from '../../../utils/CommonUtil';
interface Prop {
  condition?: any;
  openMode?: AsstRvwType; //'REQUEST' | 'REPLY' | 'READ'; //요청, 회신, 결과(읽기전용)
  handleConditionChange?: any;
  onRefresh?: () => void;
}
interface LocationState {
  upprMnuUrl?: string;
}

/**
 * 불용자산 정보 - 검토회신, 검토내역
 * @param props
 * @param ref
 * @constructor
 */
const IdleAssetRequestInfo = (props: Prop, ref) => {
  const { t } = useTranslation();
  const { openCommonModal } = useCommonModal();
  const { openMessageBar } = useMessageBar();

  const [rowData, setRowData] = useState<IdleAssetMaster>(); //요청정보
  const [rowDataRvwTgt, setRowDataRvwTgt] = useState<IdleAssetReviewResult[]>([]); //사용자의 검토 법인,공정, 통보자

  const [code, setCode] = useState<any>({});
  const [condition, setCondition] = useState<IdleAssetCondition>(props?.condition);

  // 첨부파일
  const [initParamFileUpload, setInitParamFileUpload] = useState<any>();
  const [isOpenFileUploadPopUp, setOpenFileUploadPopUp] = useState<boolean>(false);

  const [isOpenElmEmpPopup, setOpenElmEmpPopup] = useState<boolean>(false);

  //통보자
  const [infrUserIds, setInfrUserIds] = useState<string>('');

  const userSession = useSessionStore();

  useImperativeHandle(ref, () => ({
    search: (params) => {
      handleSearch(params);
    },
  }));

  useEffect(() => {
    props.handleConditionChange(condition);
    getCommonCodes();
  }, [condition.rvwReqId, condition.tgtCopCd]);

  const getCommonCodes = () => {
    if (props.openMode === 'REPLY') {
      // 대상 법인,부서,공정 조회
      if (_.isNull(rowDataRvwTgt) || rowDataRvwTgt.length == 0) {
        setCode({ tgtCopCd: null, tgtDept: null, tgtProc: null });
      } else {
        setCode({ tgtCopCd: null, tgtDept: null, tgtProc: null });

        const tgtCopCd =
          rowDataRvwTgt.reduce<{ cmnCd: string; cmnCdNm: string }[]>((acc, item) => {
            // key로 중복 체크 (법인 + 법인코드)
            if (!item.tgtCopCd) return acc;
            const key = `${item.tgtCopCd}|${item.tgtCopCd}`;
            if (!acc.some((el) => `${el.cmnCdNm}|${el.cmnCd}` === key)) {
              acc.push({ cmnCd: item.tgtCopCd, cmnCdNm: item.tgtCopCd });
            }
            return acc; //
          }, []) ?? [];

        const tgtDept = rowDataRvwTgt
          .filter((item, index, self) => {
            return (
              item.tgtCopCd === condition?.tgtCopCd &&
              index === self.findIndex((t) => t.tgtCopCd === item.tgtCopCd)
            );
          })
          .map((item) => ({
            cmnCd: item.crgeDeptCd,
            cmnCdNm: item.crgeDeptNm,
          }));

        const tgtProc = rowDataRvwTgt
          .filter(
            (item) =>
              item.tgtCopCd === condition?.tgtCopCd && item.crgeDeptCd === condition?.crgeDeptCd
          )
          .map((item) => ({
            cmnCd: item.prdnProcCd,
            cmnCdNm: item.prdnProcCdNm,
          }));

        setCode({
          tgtCopCd: tgtCopCd,
          tgtDept: tgtDept,
          tgtProc: tgtProc,
        });
      }
    }
  };

  /**
   *
   * @param condition
   */
  const handleSearch = async (params) => {
    if (params) {
      findIdleAssetMaster(params).then((result) => {
        setRowData(result[0]);
      });

      if (!params?.refresh) {
        setCode({ tgtCopCd: null, tgtDept: null, tgtProc: null });
        getAsstRvwReplyUserDept(params).then((result) => {
          setRowDataRvwTgt(result);
          const merge = { ...result[0], rvwReqId: params.rvwReqId, asstTpCd: params?.asstTpCd };
          setInfrUserIds(result[0]?.infrUserIds as string);
          setCondition(merge);
        });
      }
    }
  };

  //목록 버튼을 위한 ..
  const menuContext = useContext<MenuContextType>(MenuContext);
  const locationState: LocationState = useLocation().state;
  const [isLocationState, setLocationState] = useState<LocationState>({
    upprMnuUrl: locationState?.upprMnuUrl,
  });
  const navigateToListPage = () => {
    if (isLocationState.upprMnuUrl) menuContext.closeCurrentTab(menuContext);
  };

  return (
    <>
      <SubTitleLayout>
        <SubTitleGroup>
          <h3>{t('asst.label.요청정보', '요청정보')}</h3>
        </SubTitleGroup>
        <GlobalBtnGroup className="top">
          <Button
            css={IconButton.button}
            className="list"
            disableRipple
            onClick={navigateToListPage}
          >
            {t('com.button.목록', '목록')}
          </Button>
        </GlobalBtnGroup>
      </SubTitleLayout>
      <TableContainer css={tb.table}>
        <Table>
          <TableBody>
            <TableRow>
              <TableCell width={'10%'}>
                <span>{t('asst.label.요청번호', '요청번호')}</span>
              </TableCell>
              <TableCell width={'10%'}>
                <span>{rowData?.rvwReqId}</span>
              </TableCell>
              <TableCell width={'10%'}>
                <span>{t('asst.label.요청법인', '요청법인')}</span>
              </TableCell>
              <TableCell width={'10%'}>
                <span>{rowData?.asstRvwReqCopCd}</span>
              </TableCell>
              <TableCell width={'10%'}>
                <span>{t('asst.label.분류', '분류')}</span>
              </TableCell>
              <TableCell width={'10%'}>
                <span>{rowData?.asstTpCdNm}</span>
              </TableCell>
              <TableCell width={'10%'}>
                <span>{t('asst.label.상태', '상태')}</span>
              </TableCell>
              <TableCell width={'10%'}>
                <span>{rowData?.rvwStatCdNm}</span>
              </TableCell>
              <TableCell width={'10%'}>
                <span>{t('asst.label.첨부파일', '첨부파일')}</span>
              </TableCell>
              <TableCell width={'10%'}>
                <FileuploadBtn
                  onClick={() => {
                    setInitParamFileUpload({
                      atchFileGrId: rowData?.atchFileGrId,
                      atchFileTpCd: 'ASST_IDL_VIEW',
                      tableName: 'tb_eelmb_idl_asst_m',
                      bizName: 'asst',
                      downloadOnly: true,
                    });
                    setOpenFileUploadPopUp(true);
                  }}
                >
                  <span>{toNumber(rowData?.atchFileCnt || 0).toLocaleString()}</span>
                </FileuploadBtn>
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                <span>{t('asst.label.요청명', '요청명')}</span>
              </TableCell>
              <TableCell colSpan={5}>
                <span>{rowData?.rvwReqTitNm}</span>
              </TableCell>
              <TableCell>
                <span>{t('asst.label.요청자', '요청자')}</span>
              </TableCell>
              <TableCell>
                <span>{rowData?.dataInsUserNm}</span>
              </TableCell>
              <TableCell>
                <span>{t('asst.label.검토기한', '검토기한')}</span>
              </TableCell>
              <TableCell>
                <span>{rowData?.rvwCpltDt}</span>
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                <span>{t('asst.label.요청내용', '요청내용')}</span>
              </TableCell>
              <TableCell
                colSpan={9}
                className="editCont"
                sx={{
                  width: 200,
                  whiteSpace: 'nowrap',
                  overflow: 'auto',
                  textOverflow: 'ellipsis',
                }}
              >
                <div
                  style={{
                    whiteSpace: 'pre-wrap',
                    overflowWrap: 'anywhere',
                    wordBreak: 'break-word',
                  }}
                  dangerouslySetInnerHTML={{
                    __html: CommonUtil.safeHtmlContents(rowData?.rvwReqCtn, false),
                  }}
                ></div>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>

      {props && props.openMode === 'REPLY' && (
        <TableContainer css={tb.table}>
          <Table>
            <TableBody>
              <TableRow>
                <TableCell width={'10%'}>{t('asst.label.검토법인', '검토법인')}</TableCell>
                <TableCell width={'10%'}>
                  <ComboBox
                    options={code?.tgtCopCd}
                    // placeholder={String(t('com.label.선택', '선택'))}
                    defaultValue={condition?.tgtCopCd}
                    onChange={(value) => {
                      //handleChangeCop(value);
                      const tgtDept = rowDataRvwTgt.filter((item) => item.tgtCopCd === value);
                      if (tgtDept) {
                        setInfrUserIds(tgtDept[0]?.infrUserIds as string);
                        setCondition({
                          ...condition,
                          tgtCopCd: value,
                          crgeDeptCd: tgtDept[0]?.crgeDeptCd,
                          prdnProcCd: tgtDept[0]?.prdnProcCd,
                          infrUserNms: tgtDept[0]?.infrUserNms,
                        });
                      }
                    }}
                  />
                </TableCell>
                <TableCell width={'10%'}>
                  <span>{t('asst.label.검토부서', '검토부서')}</span>
                </TableCell>
                <TableCell width={'10%'}>
                  <ComboBox
                    options={code?.tgtDept}
                    // placeholder={String(t('com.label.선택', '선택'))}
                    defaultValue={condition?.crgeDeptCd}
                    onChange={(value) => {
                      //handleChangeDept(value);요
                      setCondition({ ...condition, crgeDeptCd: value });
                    }}
                  />
                </TableCell>
                <TableCell width={'10%'}>
                  <span>{t('asst.label.공정', '공정')}</span>
                </TableCell>
                <TableCell width={'10%'}>
                  <ComboBox
                    options={code?.tgtProc}
                    placeholder={String(t('com.label.선택', '선택'))}
                    defaultValue={condition?.prdnProcCd}
                    onChange={(value) => {
                      //handleChangeProc(value);
                      setCondition({ ...condition, prdnProcCd: value });
                    }}
                  />
                </TableCell>
                <TableCell width={'10%'}>
                  <span>{t('asst.label.검토담당자', '검토담당자')}</span>
                </TableCell>
                <TableCell width={'10%'}>
                  <span>{userSession.empNm}</span>
                </TableCell>
                <TableCell width={'10%'}>
                  <span>{t('asst.label.통보담당자', '통보담당자')}</span>
                </TableCell>
                <TableCell width={'10%'}>
                  {/* 통보자 수정x */}
                  <CustomInputWithSearch
                    className="find"
                    name="infrUserNms"
                    value={condition?.infrUserNms}
                    readOnly={true}
                    onSearchClick={() => {
                      // if ((procMgrs || []).length) {
                      setOpenElmEmpPopup(true);
                      // }
                    }}
                  />
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      )}

      {/*첨부파일팝업*/}
      {isOpenFileUploadPopUp && (
        <FileUploadPopUp
          open={isOpenFileUploadPopUp}
          close={() => setOpenFileUploadPopUp(false)}
          onCallback={(value) => {
            setOpenFileUploadPopUp(false);
          }}
          initParam={initParamFileUpload}
          downloadOnly={true}
          singleSelect={false}
          showAllDownload={true}
        />
      )}

      {/* 통보자 팝업(수정x) */}
      {isOpenElmEmpPopup && (
        <GatingContListPopUp
          open={isOpenElmEmpPopup}
          setReadonly={true}
          title={t('asst.label.통보담당자', '통보담당자')}
          initParam={infrUserIds}
          close={() => setOpenElmEmpPopup(false)}
        />
      )}
    </>
  );
};

export default React.forwardRef(IdleAssetRequestInfo);
